import React from "react";
import "../../../pages/Home/home-rpg.css";

const HomeRedesignLayout = ({ children }) => {
  return <div className="td-home-rpg">{children}</div>;
};

export default HomeRedesignLayout;
